(ns hai.notes.routes
  (:require
   [hai.notes.detail :as detail]
   [hai.notes.eql :as eql]
   [hai.notes.page :as page]
   [hai.ui.icons :as icons]
   [hai.ui.rf-sugar :refer [>e]]
   [hai.web-app.routing :as-alias routing]))

(defn routes []
  [["/notes"
    {:label "Notes"
     :icon icons/humble-note}
    [""
     {:name :notes/view
      :view page/page}]
    ["/{note/uuid}"
     {:name :notes/detail
      ::routing/window-title ::detail/window-title
      :breadcrumbs [:notes/view "Note"]
      :view detail/page
      :controllers [{:parameters {:path [:note/uuid]}
                     :start (fn [{path :path}]
                              (>e [:entity/resolve path
                                   {;; The same shape the editor's other hosts
                                    ;; resolve, so a note is one thing wherever
                                    ;; it is opened.
                                    :pattern       eql/note-eql
                                    ;; The composer's draft is seeded from the
                                    ;; note the resolve just stored — the page
                                    ;; renders once it is there, so there is no
                                    ;; frame where the two disagree.
                                    :on-success-fx [[:dispatch [::detail/mark-resolved (:note/uuid path)]]
                                                    [:dispatch [::detail/seed-draft (:note/uuid path)]]]
                                    :on-error-fx   [[:dispatch [::detail/mark-resolved (:note/uuid path)]]]}]))
                     :stop (fn [{path :path}]
                             (>e [::detail/discard-draft (:note/uuid path)]))}]}]]])
